import { render, staticRenderFns } from "./CommonFormItems.vue?vue&type=template&id=1c1f0be2"
import script from "./CommonFormItems.vue?vue&type=script&lang=js"
export * from "./CommonFormItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports